import { render } from "./Credit.vue?vue&type=template&id=490d141c&scoped=true&ts=true"
import script from "./Credit.vue?vue&type=script&lang=ts"
export * from "./Credit.vue?vue&type=script&lang=ts"

import "./Credit.vue?vue&type=style&index=0&id=490d141c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490d141c"]])

export default __exports__